/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ChatRoundedIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 16 16' {...props}>
			<path
				data-name='messenger'
				d='M8 0a8 8 0 0 0-6.939 11.982L.03 15.183a.625.625 0 0 0 .786.786l3.2-1.031A8 8 0 1 0 8 0Zm0 14.75a6.73 6.73 0 0 1-3.573-1.023.625.625 0 0 0-.523-.065l-2.311.744.745-2.306a.625.625 0 0 0-.065-.523A6.75 6.75 0 1 1 8 14.75ZM8.781 8A.781.781 0 1 1 8 7.219.781.781 0 0 1 8.781 8Zm3.125 0a.781.781 0 1 1-.781-.781.781.781 0 0 1 .781.781Zm-6.25 0a.781.781 0 1 1-.781-.781.781.781 0 0 1 .781.781Zm0 0'
				fill={color}
			/>
		</svg>
	)
}

export default ChatRoundedIcon
